import React from "react";

import { useAppSelector } from "store";
import {
    selectIndependantsRateRAG
} from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";

import RAGIndicator from "components/visuals/RAGIndicatorNew";

const IndependentsRateRAG: React.FC = () => {
    const data = useAppSelector(selectIndependantsRateRAG);

    return (
        <RAGIndicator ragIndicator={data} />
    );
};

export default IndependentsRateRAG;
